import { render, staticRenderFns } from "./coljuegosHome.vue?vue&type=template&id=97a47f78&scoped=true&"
import script from "./coljuegosHome.vue?vue&type=script&lang=js&"
export * from "./coljuegosHome.vue?vue&type=script&lang=js&"
import style0 from "./coljuegosHome.vue?vue&type=style&index=0&id=97a47f78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a47f78",
  null
  
)

export default component.exports